import React, {forwardRef, MouseEventHandler, useRef} from 'react'
import styled from 'styled-components'
import {useCenterY} from './context/VerticalPositionContext'
import {Box, BoxProps, sx, useRefObjectAsForwardedRef} from '../..'
import {PositionAwareItemProps} from './types'

const StyledPositionalItemWrapper = styled(Box)<BoxProps & PositionAwareItemProps>`
  ${sx}
`
/**
 *
 * A component that wraps its children and updates the selected item in a VerticalPositionContext context using
 * the useCenterY hook.
 *
 */

const PositionAwareItem = forwardRef<HTMLDivElement, PositionAwareItemProps>(
  ({id = '', children, sx: sxProp, testId, onItemSelect}, forwardedRef) => {
    const innerRef = useRef(null)
    useRefObjectAsForwardedRef(forwardedRef, innerRef)
    const wrapperTestId = `${testId}-wrapper`
    const {onSelectItem} = useCenterY()

    const handleClick: MouseEventHandler = event => {
      onSelectItem(event.target as HTMLElement, id)
      if (onItemSelect) onItemSelect()
    }
    return (
      <StyledPositionalItemWrapper
        onClick={handleClick}
        sx={sxProp}
        data-testid={testId ? wrapperTestId : null}
        ref={innerRef}
      >
        {children}
      </StyledPositionalItemWrapper>
    )
  }
)

PositionAwareItem.displayName = 'PositionAwareItem'
export default PositionAwareItem
